import { FaBars } from 'react-icons/fa';
import { NavLink as Link } from 'react-router-dom';
import styled from 'styled-components';
  
export const Nav = styled.nav`
  background: #f9f0e3;
  height: 85px;
  display: flex;
  justify-content: space-between;
  padding: 0.2rem calc((100vw - 1000px) / 2);
  z-index: 12;
  border-bottom: 1px solid #4e6c49;
  box-shadow: 0 4px 10px -2px #9fd0eb;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: #4e6c49;
  /* Third Nav */
  /* justify-content: flex-start; */
`;
  
export const NavLink = styled(Link)`
  color: #9fd0eb;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  &.active {
    color: #4e6c49;
  }
`;

export const NavLink2 = styled(Link)`
  color: #9fd0eb;
  display: ${({ dropdown }) => (dropdown ? "none" : "block")};
  align-items: center;
  text-decoration: none;
  width: 100%;
  cursor: pointer;
  &.active {
    color: #4e6c49;
  }
`;
  
export const Bars = styled(FaBars)`
  display: none;
  color: #9fd0eb;
  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const Dropdown = styled.div`
  display: ${({ dropdown }) => (dropdown ? "none" : "block")};
  align-items: center;
  width: 100%; 
  background:  hsl(35, 69%, 98%); 
  border-bottom: 1px solid #4e6c49; 
  @media screen and (min-width: 768px) {
    display: flex; ;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
    top = ${({ dropdown }) => (dropdown ? "0" : "100%")};
  }

  /* Second Nav */
  /* margin-right: 24px; */
  /* Third Nav */
  /* width: 100vw;
  white-space: nowrap; */
  // @media screen and (max-width: 768px) {
  //   display: none;
`
;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: -24px;
  /* Second Nav */
  /* margin-right: 24px; */
  /* Third Nav */
  /* width: 100vw;
  white-space: nowrap; */
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
  
export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  margin-right: 24px;
  /* Third Nav */
  /* justify-content: flex-end;
  width: 100vw; */
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
  
export const NavBtnLink = styled(Link)`
  border-radius: 4px;
  background: #f9f0e3;
  padding: 10px 22px;
  color: #000000;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  /* Second Nav */
  margin-left: 24px;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: #f9f0e3;
    color: #9fd0eb;
  }
`;